
import { AlertTriangle, Link, Clock, Shield } from "lucide-react";

const PoweredByAI = () => {
  const features = [
    {
      icon: <Shield className="h-8 w-8 text-spharaka-purple" />,
      title: "Autonomous Threat Response",
      description: "AI agents capable of rapid containment and auto-response of compromised endpoints minimize damage from attacks."
    },
    {
      icon: <AlertTriangle className="h-8 w-8 text-spharaka-purple" />,
      title: "Intelligent Alert Prioritization",
      description: "AI-based triaging and multi-point correlation minimize false positives and reduce alert fatigue for security teams."
    },
    {
      icon: <Link className="h-8 w-8 text-spharaka-purple" />,
      title: "Seamless Integrations",
      description: "API-driven platform integrates with existing security tools and IT infrastructure for unified security operations."
    },
    {
      icon: <Clock className="h-8 w-8 text-spharaka-purple" />,
      title: "24/7 Active Monitoring",
      description: "Always-on protection ensures continuous operational security while improving incident response times."
    }
  ];

  return (
    <section 
      className="py-12 md:py-20 relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7)), url('/lovable-uploads/acea7e4a-2f53-462b-92c7-0211ee73c2c6.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-3 md:mb-4 leading-tight text-white drop-shadow-lg">
            Powered by <span className="text-white drop-shadow-lg font-extrabold text-2xl sm:text-3xl md:text-4xl">Agentic AI</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-100 max-w-3xl mx-auto leading-relaxed px-4 drop-shadow-md">
            Spharaka XDR™ combines cutting-edge artificial intelligence with enterprise security expertise to provide comprehensive protection against modern threats.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mt-8 sm:mt-12">
          {features.map((feature, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center animate-scale-in bg-white/90 backdrop-blur-md rounded-lg p-6 border border-white/20 shadow-lg hover:bg-white/95 transition-all duration-300"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-2 sm:mb-3 px-2 text-gray-900">{feature.title}</h3>
              <p className="text-gray-700 text-xs sm:text-sm md:text-base leading-relaxed px-2">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PoweredByAI;
